import React, { useEffect, useState } from 'react';
import { classes, st } from './MainToolBar.st.css';
import FolderButton from './FolderButton/FolderButton';
import FileButton from './FileButton/FileButton';
import useObservable from '../../../../../../Shared/Hooks/useObservable.Hook';
import { getSelectedFolder } from '../../../../../Services/SelectedFolder.service';
import { getRootFolder } from '../../../../../Services/RootFolder.service';
import { Status } from '../../../../../../Constants/Permissions';
import { getUser } from '../../../../../Services/User.service';
import { ADMIN } from '../../../../../../Constants/Modals.Constants';
import { AddFolderStatus } from '../../../../../Observables/AddNewFolder.observable';
import { getAddFolderStatus } from '../../../../../Services/AddNewFolder.service';
import { getDisableButtonsStatus } from '../../../../../Services/Search.service';
import { getAppSettings } from '../../../../../Services/AppSettings.service';

const MainToolBar = () => {
  const [, selectedFolder]: any = useObservable(getSelectedFolder());
  const [, rootFolder]: any = useObservable(getRootFolder());
  const [, user]: any = useObservable(getUser());
  const [, addFolderStatus] = useObservable(getAddFolderStatus());
  const [, disableButtonStatus] = useObservable(getDisableButtonsStatus());
  const [, AppSettings]: any = useObservable(getAppSettings());
  const isMobile = AppSettings !== undefined ? AppSettings?.isMobile : '';
  const isAdmin: boolean = user?.role === ADMIN;
  const [state, setState]: any = useState({
    createFolder: {},
    uploadFile: {},
  });
  const isCreateFolderDisabled =
    (addFolderStatus !== undefined &&
      addFolderStatus !== AddFolderStatus.CLOSED) ||
    (rootFolder === undefined && selectedFolder === undefined);
  const isUploadFileDisabled =
    rootFolder === undefined && selectedFolder === undefined;
  useEffect(() => {
    if (selectedFolder) {
      const uploadFileObj = selectedFolder?.folderAuthorizedActions?.[0] || {};
      const createFolderObj =
        selectedFolder?.folderAuthorizedActions?.[1] || {};
      setState({
        createFolder: createFolderObj,
        uploadFile: uploadFileObj,
      });
    }
  }, [selectedFolder]);

  const showFolderButton =
    state?.createFolder?.status === Status.ALLOWED || isAdmin;
  const showFileButton =
    state?.uploadFile?.status === Status.ALLOWED || isAdmin;

  return (
    <div className={st(classes.mainToolBarContainer)}>
      {!disableButtonStatus ? (
        <>
          {showFolderButton ? (
            <FolderButton
              folderPermissions={state?.createFolder}
              isCreateFolderDisabled={isCreateFolderDisabled}
              isMobile={isMobile}
            />
          ) : null}
          {showFileButton ? (
            <FileButton
              uploadFilePermissions={state?.uploadFile}
              isUploadFileDisabled={isUploadFileDisabled}
              isMobile={isMobile}
            />
          ) : null}
        </>
      ) : (
        <div className={st(classes.hiddenButtonsContainer)} />
      )}
    </div>
  );
};

export default MainToolBar;
